import { GROWTH } from "./constants"
import {
	PRIMARY_TRACK,
	PRIMARY_TRACK_,
	SECONDARY_TRACK,
	SECONDARY_TRACK_,
} from "components/Transactional/Performance/components/Timeline/utils"
import { PENETRATION } from "components/Transactional/Performance/components/BenchmarkTemplateManager/Templates/constants"
import { useIntl } from "react-intl"

export const METRIC_ID =
	"phronesis.transactional.application.commercial.benchmark.timeline.tooltip"
export const DETAIL_ID = METRIC_ID + ".detail"
export const GROWTH_DATES_ID = METRIC_ID + ".growth.dates"
const GROWTH_LEGEND_ID = METRIC_ID + ".growth.legend"

export const isGrowth = (template: string): boolean => {
	return template === GROWTH
}

export const hasDetail = (template: string, dataKey: string): boolean => {
	return (
		!isGrowth(template) && [SECONDARY_TRACK, SECONDARY_TRACK_].includes(dataKey)
	)
}

export const hasGrowthDetail = (template: string, dataKey: string): boolean => {
	return isGrowth(template) && dataKey === PRIMARY_TRACK
}

const isPenetration = (
	metric: string,
	dataKey: string,
	keys: string[]
): boolean => {
	return metric === PENETRATION && keys.includes(dataKey)
}

const getKeySymbol = (
	primaryMetric: string,
	secondaryMetric: string,
	dataKey: string
) => {
	if (isPenetration(primaryMetric, dataKey, [PRIMARY_TRACK, SECONDARY_TRACK]))
		return primaryMetric
	if (
		isPenetration(secondaryMetric, dataKey, [PRIMARY_TRACK_, SECONDARY_TRACK_])
	)
		return secondaryMetric
}

const growthLegend = (dataKey: string) => {
	const intl = useIntl()
	return intl.formatMessage(
		{
			id: GROWTH_LEGEND_ID,
		},
		{ legend: dataKey }
	)
}

export const getSymbol = (
	template: string,
	primaryMetric: string,
	secondaryMetric: string,
	dataKey: string
) => {
	return isGrowth(template)
		? template
		: getKeySymbol(primaryMetric, secondaryMetric, dataKey)
}

export const getLegend = (date: string, template: string, dataKey: string) => {
	return isGrowth(template) ? growthLegend(dataKey) : date
}

export const getDetailTrack = (
	detail: number,
	template: string,
	dataKey: string
) => {
	return hasGrowthDetail(template, dataKey) || hasDetail(template, dataKey)
		? detail
		: undefined
}
